var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TableList',{ref:"table",attrs:{"cols":_vm.cols,"list":_vm.list,"height":_vm.tableHeight,"rowHeight":100},scopedSlots:_vm._u([{key:"operateSubTypeSlot",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.operateSubTypeMap[row.operateSubType] || '')+" ")]}},{key:"operateStatusSlot",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(_vm.operateStatusMap[row.operateStatus] || '')+" ")]}},{key:"staffIdSlot",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.staffMap[row.staffId]))])]}},{key:"opcolsSlot",fn:function(ref){
var row = ref.row;
return [_c('el-button',{attrs:{"type":"link"},on:{"click":function($event){return _vm.jumpDetail(row)}}},[_vm._v("查看明细")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }